<template>
    <el-dialog
        :visible.sync="Visible"
        title="凭证生成处理中"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="canClose"
        append-to-body
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <div class="el-dialog__body">
            <div class="eldiv">
                <span style="color: red">查询参数</span>
                <el-divider direction="vertical"></el-divider>
                <span> 制单日期:{{ voucherDate(queryParams) }}</span>
                <el-divider></el-divider>
                <span> 单据类型:{{ queryParams.billTypeNames }}</span>
                <el-divider></el-divider>
                <span>同步组织:{{ queryParams.storeNames }}</span>
                <el-divider></el-divider>
                <span>生成方式:{{ isOrNo(queryParams) }}</span>
            </div>
            <div class="el-steps el-steps--horizontal">
                <!---->
                <div
                    class="el-step is-horizontal"
                    style="flex-basis: 50%; margin-right: 0px"
                >
                    <div class="el-step__head is-process" v-if="step1 == 1">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: 0ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-loading"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-process">
                                    基础信息校验
                                </div>
                                <div class="el-step__description is-process">
                                    共{{ step1num }}条数据，校验中
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-step__head is-finish" v-if="step1 == 2">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: 0ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-check"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-finish">
                                    基础信息校验
                                </div>
                                <div class="el-step__description is-finish">
                                    已校验成功
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-step__head is-error" v-if="step1 == 3">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: 0ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-close"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-error">
                                    基础信息校验
                                </div>
                                <div class="el-step__description is-error">
                                    基础信息校验失败
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="el-step is-horizontal"
                    style="flex-basis: 50%; margin-right: 0px"
                >
                    <div class="el-step__head is-wait" v-if="step2 == 0">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: -150ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-text">
                            <div class="el-el-step__icon-inner">2</div>
                        </div>
                        <div class="el-step__main">
                            <div class="el-step__title is-wait">凭证生成</div>
                        </div>
                    </div>
                    <div class="el-step__head is-process" v-if="step2 == 1">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: -150ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-loading"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-process">
                                    凭证生成
                                </div>
                                <div class="el-step__description is-process">
                                    共{{ step2num }}条数据，处理中
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-step__head is-finish" v-if="step2 == 2">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: -150ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-check"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-finish">
                                    凭证生成
                                </div>
                                <div class="el-step__description is-finish">
                                    已生成凭证
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-step__head is-error" v-if="step2 == 3">
                        <div class="el-step__line" style="margin-right: 0px">
                            <i
                                class="el-step__line-inner"
                                style="
                                    transition-delay: -150ms;
                                    border-width: 0px;
                                    width: 0%;
                                "
                            ></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <i class="el-step__icon-inner el-icon-close"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-error">
                                    凭证生成
                                </div>
                                <div class="el-step__description is-error">
                                    凭证生成失败
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!---->
                <div class="el-step is-horizontal" style="flex-basis: 20%">
                    <div class="el-step__head is-wait" v-if="step3 == 0">
                        <div class="el-step__line">
                            <i class="el-step__line-inner"></i>
                        </div>
                        <div class="el-step__icon is-text">
                            <div class="el-el-step__icon-inner">3</div>
                        </div>
                        <div class="el-step__main">
                            <div class="el-step__title is-wait">完成</div>
                        </div>
                    </div>
                    <div class="el-step__head is-finish" v-if="step3 == 2">
                        <div class="el-step__line">
                            <i class="el-step__line-inner"></i>
                        </div>
                        <div class="el-step__icon is-icon">
                            <!---->
                            <i class="el-step__icon-inner el-icon-check"></i>
                            <div class="el-step__main">
                                <div class="el-step__title is-finish">完成</div>
                                <div class="el-step__description is-finish">
                                    complete
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!---->
            </div>
        </div>
        <div class="errormsg" v-if="step1errormsg.length > 0">
            基础信息校验失败信息：
            <el-button
                @click="exportExcel"
                size="mini"
                class="floatright"
                type="primary"
                >点击导出</el-button
            >
            <el-table
                :data="step1errormsg"
                size="mini"
                border
                :highlight-current-row="true"
                class="toggletable"
                ref="detail"
                id="out-table"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="错误项"
                    prop="basicName"
                    min-width="80"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="错误项名称"
                    prop="name"
                    min-width="80"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="错误项编码"
                    prop="code"
                    min-width="80"
                    fixed
                ></el-table-column>
            </el-table>
        </div>
        <div class="errormsg" v-if="step2errormsgList.length > 0">
            凭证生成失败信息：
            <el-table
                :data="step2errormsgList"
                size="mini"
                border
                :highlight-current-row="true"
                class="toggletable"
                ref="detail"
                id="out-table1"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="门店编码"
                    prop="shopCode"
                    min-width="50"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="门店名称"
                    prop="shopName"
                    min-width="60"
                    fixed
                ></el-table-column>
                <el-table-column
                    label="结果"
                    class="text-wrapper"
                    prop="voucherResult"
                    min-width="120"
                    fixed
                ></el-table-column>
            </el-table>
        </div>
        <div class="errormsg" v-if="step2errormsgStr != ''">
            凭证生成失败信息：
            {{ step2errormsgStr }}
        </div>
    </el-dialog>
</template>

<script>
import moment from 'moment'

import config from '../../common/config'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
    data() {
        return {
            Visible: false,
            step1: 2, // 1 process  2 finish  3 error
            step2: 1, // 0 wait  1 process  2 finish  3 error
            step3: 0, // 0 wait  2 finish
            activestep: 1, //0 step1  1 step2  3 finish
            step1num: 0,
            step2num: 0,
            step1errormsg: [],
            step2errormsgList: [],
            step2errormsgStr: '',
            canClose: false,
            queryParams: '',
            loading: false,
            loadingText: '加载中'
        }
    },

    methods: {
        voucherDate(val) {
            return `${moment(val.startTime).format('YYYY-MM-DD')}至${moment(
                val.endTime
            ).format('YYYY-MM-DD')}`
        },
        isOrNo(val) {
            return val.groupType == '1'
                ? '单张'
                : val.groupType == '2'
                ? '按日期合并'
                : val.groupType == '3'
                ? '按对方机构合并'
                : '按业务日期生成'
        },
        showParams(queryParams1) {
            this.queryParams = queryParams1
            if (this.queryParams.isSSSF) {
                this.queryParams.billTypeNames = '实收实付单'
            } else if (this.queryParams.isYSYF) {
                this.queryParams.billTypeNames = '应收应付单'
            } else {
                this.queryParams.billTypeNames =
                    this.queryParams.billTypeNames.join(',')
            }
            this.queryParams.storeNames = this.queryParams.storeNames.join(',')
        },
        beginStep(queryDatas, step1num) {
            var _this = this
            _this.loading = true
            _this.loadingText = '加载中'

            cf.event.on('app.chat.messageReceived', function (message) {
                if (queryDatas.tick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            _this.step1num = step1num
            _this.step1 = 1
            _this.step2 = 0
            _this.step3 = 0
            _this.activestep = 0
            _this.step1errormsg = ''
            _this.step2errormsgStr = ''
            _this.step2errormsgList = []
            _this.canClose = false
            _this.Visible = true
        },
        errorstep1(errormsg) {
            this.step1 = 3
            this.canClose = true
            this.loading = false
        },
        failstep1(errormsg) {
            this.step1 = 3
            this.step1errormsg = errormsg
            this.canClose = true
            this.loading = false
        },
        failstep2(errormsg) {
            if (errormsg != undefined) {
                if (typeof errormsg == 'string') {
                    this.step2errormsgStr = errormsg
                } else {
                    this.step2errormsgList = errormsg
                }
            }
            this.step2 = 3
            this.canClose = true
            this.loading = false
        },
        successstep1(step2num) {
            this.step2num = step2num
            this.step1 = 2
            this.step2 = 1
            this.activestep = 1
            this.canClose = false
        },
        successstep2() {
            this.step2 = 2
            this.step3 = 2
            this.activestep = 3
            this.canClose = true
            this.loading = false
        },
        changeCanClose() {
            this.canClose = true
            this.loading = false
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#out-table').removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#out-table').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#out-table'),
                    xlsxParam
                )
            }
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                FileSaver.saveAs(
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    '基础信息校验失败信息.xlsx'
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        }
    }
}
</script>

<style>
.text-wrapper {
    word-wrap: break-word;
    word-break: break-all;
}
.eldiv {
    margin-top: -48px;
    margin-bottom: 40px;
}
.myshowup.el-button {
    border-radius: 16px;
}
.el-append-search {
    background-color: #409eff !important;
    color: #fff !important;
}
.graybg {
    background: #f9f9f9 !important;
}
.is-finish .el-step__icon-inner[class*='el-icon']:not(.is-status) {
    font-size: 26px;
    font-weight: 600;
    border: solid 2px #409eff;
    border-radius: 36px;
    padding: 4px;
    margin-right: 6px;
}

.is-process .el-step__icon-inner[class*='el-icon']:not(.is-status) {
    font-size: 32px;
    font-weight: 800;
    margin-right: 8px;
    color: #409eff;
}

.is-wait .el-step__icon-inner[class*='el-icon']:not(.is-status) {
    font-size: 32px;
    margin-right: 8px;
}

.is-error .el-step__icon-inner[class*='el-icon']:not(.is-status) {
    font-size: 26px;
    font-weight: 600;
    border: solid 2px #f56c6c;
    border-radius: 36px;
    padding: 4px;
    margin-right: 6px;
}
.el-step_number_text {
    font-size: 26px;
    border: solid 2px #c0c4cc;
    border-radius: 36px;
    padding: 4px;
    margin-right: 6px;
}

.el-step__head .is-finish .el-step__line {
    color: #409eff;
}

.is-finish .el-step__icon.is-icon {
    width: 200px;
}

.is-process .el-step__icon.is-icon {
    width: 200px;
}
.is-wait .el-step__icon.is-icon {
    width: 200px;
}

.is-error .el-step__icon.is-icon {
    width: 200px;
}

.is-wait .el-step__icon.is-text {
    float: left;
    margin-left: 20px;
    margin-right: 6px;
}
.is-wait .el-step__main {
    float: left;
}

.is-wait .el-step__line {
    left: 150px !important;
}
.el-step__title.is-process {
    color: #409eff !important;
}
.is-finish .el-step__line {
    background-color: #409eff;
}
.el-step__title .is-finish {
    font-weight: 600;
}

.el-step__description {
    padding-right: 0;
}
.el-step__icon {
    width: 36px;
    height: 36px;
}
.errormsg {
    padding: 20px 40px;
    color: #f56c6c;
}
.floatright {
    float: right;
}
</style>
